import { render, staticRenderFns } from "./PoultryHouseMenu.vue?vue&type=template&id=57faafae&scoped=true&"
import script from "./PoultryHouseMenu.vue?vue&type=script&lang=js&"
export * from "./PoultryHouseMenu.vue?vue&type=script&lang=js&"
import style0 from "./PoultryHouseMenu.vue?vue&type=style&index=0&id=57faafae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57faafae",
  null
  
)

export default component.exports